import React, { FC } from 'react';
import { PropertyType } from 'esa-ui-library/lib/types';
import { ATOMO_QA_API } from './RoundHistory.const';
import styles from './RoundHistory.module.scss';
import { Button } from 'esa-ui-library';

interface RoundHistoryProps {
	transaction: PropertyType;
}

const RoundHistory: FC<RoundHistoryProps> = ({ transaction }): JSX.Element => {
	const envURL = process.env.REACT_APP_ROUND_HISTORY_URL ?? ATOMO_QA_API;
	const iframeSrc = `${envURL}${transaction.round_history_api_url}`;

	const handleCopy = async () => {
		try {
			await navigator.clipboard.writeText(iframeSrc);
			alert('Link copied to clipboard');
		} catch (err) {
			alert('Failed to copy link');
		}
	};
	return (
		<section className={styles.Content}>
			<iframe title='Round History' src={iframeSrc} width='550px' height='100%' />
			<Button primary small onClick={handleCopy} className={styles.CopyButton}>
				Copy Link
			</Button>
		</section>
	);
};
export { RoundHistory };
